import { render, staticRenderFns } from "./app_nav.vue?vue&type=template&id=a9a2bb4c&scoped=true&"
import script from "./app_nav.vue?vue&type=script&lang=js&"
export * from "./app_nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a2bb4c",
  null
  
)

export default component.exports